<template>
    <div>
        <!-- <div class="base-form-div">
            <el-form size="mini" :label-position="labelPosition" label-width="100px" :model="formSet">
                <el-form-item label="平移步长">
                    <el-select v-model="formSet.model">
                        <el-option v-for="(item) in models" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="旋转步长">
                    <el-select v-model="formSet.model">
                        <el-option v-for="(item) in models" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div> -->
        <div class="operate-div">
            <el-button :disabled="start" size="mini" type="primary" @click="setStart">开启</el-button>
            <el-button :disabled="start" size="mini" type="primary" @click="setStop">关闭</el-button>
        </div>
        <div class="info-box">
            <ul>
                <li>键盘按键说明</li>
                <li>W(↑)：前进</li>
                <li>A(←)：左移</li>
                <li>S(↓)：后退</li>
                <li>D(→)：右移</li>
                <li>Q：向左旋转</li>
                <li>E：向右旋转</li>
                <li>SHIFT + W(↑)：抬高</li>
                <li>SHIFT + S(↓)：降低</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            start: false,
            formSet: {

            }
        };
    },

    mounted() {

    },
    methods: {
        setStart(){
            DBmap.keyboard.enable=true;
        },
        setStop(){
            DBmap.keyboard.enable=false;
        }
    },
};
</script>

<style lang="scss" scoped>
.operate-div {
    display: flex;
    align-items: center;
    justify-content: center;
}
.info-box ul{
  text-align: left;
  list-style: none;
  color:#ffffff;
}

.info-box ul li{
  margin: 10px 5px;
}

</style>